var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100vh","overflow":"hidden"}},[(_vm.url)?_c('iframe',{attrs:{"src":_vm.url,"width":"100%","height":"100%","frameborder":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }